<template lang="pug">
  .centered
    el-form(id="RecoverPassword-recoverForm")
      el-form-item(id="RecoverPassword-recoverForm-item1")
        h3(id="RecoverPassword-recoverFormHeader")
          span(id="RecoverPassword-recoverFormHeaderText-noReason" v-if='!reason') {{ $t('Password recovery.') }}
          span(id="RecoverPassword-recoverFormHeaderText-Reason" v-if='reason') {{ $t('Password recovery of')}} {{ $t(reason).replace('_', ' ') }} {{ $t('password')}}.
      el-form-item(id="RecoverPassword-recoverForm-item2")
        span(id="RecoverPassword-recoverFormInstructions") {{ $t('Enter your email address (same as your login). A message containing further instructions will be sent to that address.') }}
      el-form-item(id="RecoverPassword-recoverForm-item3")
        el-input(id="RecoverPassword-recoverFormEmailInput" v-model='emailAddress', type='email', @input='changedEmailInput')
      el-form-item(id="RecoverPassword-recoverForm-item4")
        el-button.float-right(id="RecoverPassword-recoverFormSubmitButton" type='success', size='mini', @click='sendResetPasswordLink', :disabled='!emailAddressValid')
          span(id="RecoverPassword-recoverFormSubmitButtonText") {{ $t('Send')}}
      el-form-item(id="RecoverPassword-recoverFormResponse" v-if='responseStatus')
        span.error(id="RecoverPassword-errorResponse" v-if='responseStatus >= 500') {{$t('Unable to recover password.')}} {{responseMessage}}
        span.warning(id="RecoverPassword-warningResponse" v-if='responseStatus === 403') {{$t('Email not found.')}}
        span.success(id="RecoverPassword-successResponse" v-if='responseStatus === 200') {{$t('Message was sent. Check your mailbox for further instructions.')}}
</template>
<script>
import Vue from 'vue'
export default {
  components: {
  },
  created () {
    this.reason = this.$route.params.type
  },
  data () {
    return {
      errors: {},
      emailAddress: '',
      emailAddressValid: false,
      responseStatus: undefined,
      responseMessage: '',
      reason: undefined
    }
  },
  methods: {
    async sendResetPasswordLink () {
      try {
        const response = await Vue.axios.post('user/sendResetPasswordLink', {
          email: this.emailAddress
        }, { disableResponseInterceptors: true })
        this.responseStatus = response.status
        this.responseMessage = ''
      } catch (error) {
        this.responseStatus = error.response.status
        this.responseMessage = error.response.data ? error.response.data.message : ''
      }
    },
    changedEmailInput () {
      this.emailAddressValid = this.__validateEmail(this.emailAddress)
    },
    __validateEmail (mail) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(mail)) {
        return true
      }
      return false
    }
  },
  computed: {
    users () {
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.warning {
  color: $--color-warning;
}
.success {
  color: $--color-success;
}

</style>



// WEBPACK FOOTER //
// src/components/User/RecoverPassword.vue